export enum DeliveryType {
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY',
  Drone = 'DRONE',
}

export enum DeliveryStatus {
  Waiting = 'WAITING',
  Preparing = 'PREPARING',
  RiderAccepted = 'RIDER_ACCEPTED',
  RiderPickedUp = 'RIDER_PICKED_UP',
  Delivering = 'DELIVERING',
  DroneLoading = 'DRONE_LOADING',
  DroneTakeoff = 'DRONE_TAKEOFF',
  DroneFlying = 'DRONE_FLYING',
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  Exception = 'EXCEPTION',
}

export const DELIVERY_STATUS_LABELS: Record<DeliveryStatus, string> = {
  [DeliveryStatus.Waiting]: '等待处理',
  [DeliveryStatus.Preparing]: '准备中',
  [DeliveryStatus.RiderAccepted]: '骑手已接单',
  [DeliveryStatus.RiderPickedUp]: '骑手已取餐',
  [DeliveryStatus.Delivering]: '配送中',
  [DeliveryStatus.DroneLoading]: '无人机装载中',
  [DeliveryStatus.DroneTakeoff]: '无人机已起飞',
  [DeliveryStatus.DroneFlying]: '无人机配送中',
  [DeliveryStatus.Arrived]: '已抵达',
  [DeliveryStatus.Completed]: '配送完成',
  [DeliveryStatus.Exception]: '配送异常',
}
